import { useTranslation } from 'react-i18next';
import { TextField, TextFieldProps } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const NameField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();

  return (
    <TextField<InfluencerFormKeys>
      title={t('TextForm.Name')}
      name={InfluencerSharedKeys.name}
      help={t('Tooltip.Influencer Name')}
      placeholder={t<string>('Influencer.CommonName')}
      {...props}
    />
  );
};
